import template from './template.html';
import './style.less';

export default function() {
  return {
    restrict: 'E',
    template,
    scope: {
      hours: '=',
      minutes: '=',
      update: '&'
    },
    link: function(scope) {
      scope.activate = () => {
        scope.minutes = scope.minutes || 0;
        scope.lastHours = scope.hours;

        if (scope.hours === 0) {
          scope.displayHours = 12;
          scope.displayPM = false;
          return;
        }

        if (scope.hours === 12) {
          scope.displayHours = 12;
          scope.displayPM = true;
          return;
        }

        if (scope.hours > 12) {
          scope.displayHours = scope.hours % 12;
          scope.displayPM = true;
          return;
        }

        if (scope.hours < 12) {
          scope.displayHours = scope.hours;
          scope.displayPM = false;
          return;
        }

        scope.hours = 12;
        scope.lastHours = scope.hours;
        scope.displayHours = scope.hours;
        scope.displayPM = true;
      };

      scope.activate();

      scope.updateHours = () => {
        if (scope.displayHours === 13) {
          scope.displayHours = 1;
        }

        if (scope.displayHours === 12) {
          scope.displayPM = !scope.displayPM;
        }

        if (scope.displayHours === 0) {
          scope.displayHours = 12;
        }

        if (scope.displayHours === 11 && scope.lastHours === 12) {
          scope.displayPM = !scope.displayPM;
        }

        scope.lastHours = scope.displayHours;

        scope.updateAttrs();
      };

      scope.updateAttrs = () => {
        scope.hours = (scope.displayHours === 12 ? 0 : scope.displayHours) + (scope.displayPM ? 12 : 0);

        scope.update();
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/timeSelect/index.js